import React, { useEffect } from "react";
import "./All_Shibir.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Common_Title_2 from "../common/common_components/common_title_2/Common_Title_2";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllEvent, SingleEventCategories } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";
import { decodeId, encodeId } from "../../utils/common";

const All_Shibir = () => {



  const [searchParams] = useSearchParams();
  const eventCategoryId = searchParams.get("event_category_id");

  const dispatch = useDispatch();
  const events = useSelector((state) => state.common.all_events);
  const eventscat = useSelector((state) => state.common.event_category);



  useEffect(() => {
    dispatch(SingleEventCategories({ id: decodeId(eventCategoryId) }));
    dispatch(AllEvent({ event_category_id: decodeId(eventCategoryId) }));
  }, [dispatch])

  const navigate = useNavigate()

  const breadcrumbs = [
    { label: "EXPLORE", link: "/explore", active: false },
    {
      label: "SHIBIR & EVENT REGISTRATIONS",
      link: "/event-registration",
      active: false,
    },
    { label: eventscat?.name || "Events & Shibirs", link: "", active: true },
  ];


  const data = [
    {
      img: "/assets/images/all_shibir/img1.png",
      label: "Inner Engineering Online",
    },
    {
      img: "/assets/images/all_shibir/img2.png",
      label: "Inner Engineering Online",
    },
    {
      img: "/assets/images/all_shibir/img3.png",
      label: "Inner Engineering Online",
    },
  ];

  return (
    <section className="All_Shibir">
      <div className="container">
        <Breadcrumb_Comp data={breadcrumbs} />
        <Common_Title_2 subText={`${eventscat?.name || "All Events & Shibirs"}`} />

        <div className="all_shibir_cards">
          <div className="row">
            {events?.map((item) => {
              return (
                <div className="col-md-6 mb-4">
                  <div className="shibir_card" onClick={() => { navigate(`/shibir-registration/${encodeId(item?.event_id)}`) }}>
                    <div className="img_holder">
                      <img src={IDS.IMG_URL + item?.Event?.image} className="shibir_img" />
                    </div>
                    <div className="overlay"></div>
                    <p className="shibir_name">{item?.name || " "}</p>

                    <div className="type_holder">
                      <span className="type_text">{item?.Event?.Event_type?.name || ""}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
    // <section className="All_Shibir">
    //   <div className="container">
    //     <Breadcrumb_Comp data={breadcrumbs} />
    //     <Common_Title_2 subText="Shibirs" />

    //     <div className="all_shibir_cards">
    //       <div className="row">
    //         {data?.map((item) => {
    //           return (
    //             <div className="col-md-6 mb-4">
    //               <div className="shibir_card" onClick={() => { navigate("/shibir-registration/4") }}>
    //                 <div className="img_holder">
    //                   <img src={item?.img} className="shibir_img" />
    //                 </div>
    //                 <div className="overlay"></div>
    //                 <p className="shibir_name">{item?.label}</p>

    //                 <div className="type_holder">
    //                   <span className="type_text">In-Person</span>
    //                 </div>
    //               </div>
    //             </div>
    //           );
    //         })}
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
};

export default All_Shibir;
